import { useReducer } from "react";
import {
  DTHoverAction,
  DTHoverDispatchContext,
  DTHoverState,
  DTHoverStateContext,
} from "./DTHoverContext";

export function DTHoverProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DTHoverStateContext.Provider value={state}>
      <DTHoverDispatchContext.Provider value={dispatch}>
        {children}
      </DTHoverDispatchContext.Provider>
    </DTHoverStateContext.Provider>
  );
}

function reducer(state: DTHoverState, action: DTHoverAction): DTHoverState {
  switch (action.type) {
    case "HOVER_START": {
      return {
        ...state,
        hoveredColumnId: action.payload.columnId,
      };
    }
    case "HOVER_END": {
      // If the column currently in state is not the same as the column that is being left, don't update the state
      if (state.hoveredColumnId !== action.payload.columnId) {
        return state;
      }
      return {
        ...state,
        hoveredColumnId: null,
      };
    }
    case "RESIZE_START": {
      return {
        ...state,
        resizingColumnId: action.payload.columnId,
      };
    }
    case "RESIZE_END": {
      return {
        ...state,
        resizingColumnId: null,
      };
    }
    default: {
      throw new Error("Unknown action");
    }
  }
}

const initialState: DTHoverState = {
  hoveredColumnId: null,
  resizingColumnId: null,
};
